// extracted by mini-css-extract-plugin
export var base = "checkbox-module--base--7beb7";
export var disabled = "checkbox-module--disabled--b0f16";
export var error = "checkbox-module--error--28caa";
export var icon = "checkbox-module--icon--e9d91";
export var wrapper = "checkbox-module--wrapper--2ae9b";